// // Support component names relative to this directory:
// var componentRequireContext = require.context("components", true);
// var ReactRailsUJS = require("react_ujs");
// ReactRailsUJS.useContext(componentRequireContext);
//
import ReactOnRails from 'react-on-rails';

import Ad from '../components/adBanners/ad';
import AdsLoader from '../components/adBanners/adsLoader';
import AdsImpressionsTracker from '../components/adBanners/adsImpressionsTracker';
import Popups from '../components/flexiblePopups/show';
import SubscriptionHandler from '../components/subscriptions/handler';
import NavigationSide from '../components/navigation/side';
import NavigationSearchOverlay from '../components/navigation/searchOverlay';
import InlineInput from '../components/subscriptions/inlineInput';
import LazyInlineInput from '../components/subscriptions/lazyInlineInput';
import ArticlesList from '../components/articlesList/index';
import FeaturedLogos from '../components/featuredLogos/carousel';
import SearchField from '../components/search/field';
import HomeSubscription from '../components/subscriptions/form';
import Team from '../components/team/index';
import FlexibleForm from '../components/flexible_form/root';
import SearchBox from '../components/search/field';
import TopNotificationLayer from '../components/topNotification/layer';

// This is how react_on_rails can see the HelloWorld in the browser.
ReactOnRails.register({
    Ad, AdsLoader, AdsImpressionsTracker, Popups, SubscriptionHandler, NavigationSide, NavigationSearchOverlay,
    InlineInput, LazyInlineInput, ArticlesList, FeaturedLogos, SearchField, HomeSubscription, Team, FlexibleForm,
    SearchBox, TopNotificationLayer
});
